/**
 * ApiQuotaBar — Persistent quota info bar for TheOddsAPI section
 * Shows remaining requests, used requests, and last update time.
 *
 * Props:
 *   remaining   — Number of remaining API requests (or null)
 *   used        — Number of used API requests (or null)
 *   lastUpdated — Date object of last quota update (or null)
 */

import './ApiQuotaBar.css'

function ApiQuotaBar({ remaining, used, lastUpdated }) {
  const timeStr = lastUpdated
    ? lastUpdated.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })
    : '--:--'

  const hasData = remaining !== null && remaining !== undefined

  return (
    <div className="aqb-bar">
      <div className="aqb-item">
        <span className="aqb-label">Remaining:</span>
        <span className={`aqb-value ${hasData ? 'aqb-green' : ''}`}>
          {hasData ? remaining.toLocaleString() : '—'}
        </span>
      </div>
      <span className="aqb-divider">|</span>
      <div className="aqb-item">
        <span className="aqb-label">Used:</span>
        <span className={`aqb-value ${hasData ? 'aqb-green' : ''}`}>
          {used !== null && used !== undefined ? used.toLocaleString() : '—'}
        </span>
      </div>
      <span className="aqb-divider">|</span>
      <div className="aqb-item">
        <span className="aqb-label">Updated:</span>
        <span className="aqb-value aqb-time">{timeStr}</span>
      </div>
    </div>
  )
}

export default ApiQuotaBar
